import React from 'react'

export const RealReviewsSection = () => {
    return (
        <>
            {/* ===== REVIEWS ===== */}
            <section style={{ background: "#fff" }}>
                <div className="container">
                    <h2 className="zzx_section-title">What Travellers Say</h2>
                    <p className="zzx_section-sub">Real reviews from real guests</p>
                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="zzx_review-card">
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        alt=""
                                        className="zzx_reviewer-avatar"
                                        src="https://randomuser.me/api/portraits/women/44.jpg"
                                    />
                                    <div>
                                        <div className="zzx_reviewer-name">Priya Sharma</div>
                                        <div className="zzx_reviewer-country">
                                            <i className="bi bi-geo-alt" /> Bengaluru, India
                                        </div>
                                        <div className="zzx_review-stars">★★★★★</div>
                                    </div>
                                </div>
                                <p className="zzx_review-text">
                                    "Absolutely seamless booking experience! Found our dream villa in
                                    Goa at half the price I expected. The free cancellation was a huge
                                    relief. Will always use StayEase!"
                                </p>
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <span
                                        style={{ fontSize: "0.75rem", color: "#aaa", fontWeight: 600 }}
                                    >
                                        Goa Beach Villa · May 2025
                                    </span>
                                    <span className="zzx_prop-rating" style={{ fontSize: "0.8rem" }}>
                                        9.8
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="zzx_review-card">
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        alt=""
                                        className="zzx_reviewer-avatar"
                                        src="https://randomuser.me/api/portraits/men/32.jpg"
                                    />
                                    <div>
                                        <div className="zzx_reviewer-name">Rohan Mehta</div>
                                        <div className="zzx_reviewer-country">
                                            <i className="bi bi-geo-alt" /> Mumbai, India
                                        </div>
                                        <div className="zzx_review-stars">★★★★★</div>
                                    </div>
                                </div>
                                <p className="zzx_review-text">
                                    "The Genius discount saved me ₹4,000 on my Udaipur trip. The
                                    property was exactly as shown in the photos. Customer support
                                    resolved my query within minutes. 10/10!"
                                </p>
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <span
                                        style={{ fontSize: "0.75rem", color: "#aaa", fontWeight: 600 }}
                                    >
                                        Udaipur Lake Palace · Apr 2025
                                    </span>
                                    <span className="zzx_prop-rating" style={{ fontSize: "0.8rem" }}>
                                        9.5
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="zzx_review-card">
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        alt=""
                                        className="zzx_reviewer-avatar"
                                        src="https://randomuser.me/api/portraits/women/68.jpg"
                                    />
                                    <div>
                                        <div className="zzx_reviewer-name">Aisha Khan</div>
                                        <div className="zzx_reviewer-country">
                                            <i className="bi bi-geo-alt" /> Delhi, India
                                        </div>
                                        <div className="zzx_review-stars">★★★★★</div>
                                    </div>
                                </div>
                                <p className="zzx_review-text">
                                    "Booked a last-minute stay in Manali and couldn't be happier. The
                                    filter system made it so easy to find pet-friendly properties with
                                    mountain views. Highly recommend!"
                                </p>
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <span
                                        style={{ fontSize: "0.75rem", color: "#aaa", fontWeight: 600 }}
                                    >
                                        Manali Mountain Lodge · Mar 2025
                                    </span>
                                    <span className="zzx_prop-rating" style={{ fontSize: "0.8rem" }}>
                                        9.2
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ===== NEWSLETTER ===== */}
            <section style={{ background: "var(--light-bg)" }}>
                <div className="container">
                    <div className="zzx_newsletter-section">
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <i
                                    className="bi bi-envelope-heart-fill"
                                    style={{
                                        fontSize: "2.5rem",
                                        color: "var(--primary)",
                                        marginBottom: 14,
                                        display: "block"
                                    }}
                                />
                                <h3>Get Exclusive Deals in Your Inbox</h3>
                                <p>
                                    Subscribe and be the first to know about our best offers, seasonal
                                    discounts, and travel inspiration.
                                </p>
                                <div className="row g-2">
                                    <div className="col-8">
                                        <input
                                            className="zzx_newsletter-input"
                                            placeholder="Enter your email address"
                                            type="email"
                                        />
                                    </div>
                                    <div className="col-4">
                                        <button className="zzx_btn-subscribe">Subscribe</button>
                                    </div>
                                </div>
                                <p
                                    style={{
                                        fontSize: "0.78rem",
                                        color: "#aaa",
                                        fontWeight: 600,
                                        marginTop: 10
                                    }}
                                >
                                    No spam, unsubscribe anytime. 500,000+ happy subscribers.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    )
}
